export enum CustomEventTypesEnum {
  open_popup = 'open_popup',
  start_webinar = 'start_webinar',
}
